import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Dialog from '@alltrails/denali/components/Dialog';
import Sign from '@alltrails/denali/illustrations/Sign';
import { updateDynamicStyleIds } from '@alltrails/maps/redux/reducer';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import { useAppDispatch, useAppSelector } from '@/utils/redux';

type ExploreConditionsMobileWarningProps = {
  isMobile: boolean;
};

const ExploreConditionsMobileWarning = ({ isMobile }: ExploreConditionsMobileWarningProps) => {
  const dispatch = useAppDispatch();
  const { activeCondition, dynamicStyleIds } = useAppSelector(state => ({
    activeCondition: state.conditions.activeCondition,
    dynamicStyleIds: state.map.dynamicStyleIds
  }));

  const [isOpen, setIsOpen] = useState(false);
  const [previousActiveCondition, setPreviousActiveCondition] = useState<ConditionStyleId>();

  useEffect(() => {
    if (isMobile && activeCondition) {
      setIsOpen(true);
      setPreviousActiveCondition(activeCondition);
    }
  }, [isMobile, activeCondition]);

  useEffect(() => {
    if (!isMobile && previousActiveCondition) {
      dispatch(updateDynamicStyleIds([...dynamicStyleIds, previousActiveCondition]));
      setPreviousActiveCondition(undefined);
    }
  }, [dispatch, dynamicStyleIds, isMobile, previousActiveCondition]);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!isMobile && isOpen) {
      onClose();
    }
  }, [isMobile, isOpen, onClose]);

  return isOpen ? (
    <Dialog
      icon={<Sign size="sm" />}
      title={<FormattedMessage defaultMessage="Expand browser window" />}
      body={<FormattedMessage defaultMessage="Make the map larger to show real-time trail conditions" />}
      buttons={{
        primary: {
          text: <FormattedMessage defaultMessage="Got it" />,
          onClick: onClose,
          testId: 'explore-conditions-mobile-warning-got-it'
        }
      }}
      onRequestClose={onClose}
    />
  ) : null;
};

export default ExploreConditionsMobileWarning;
